import { render, staticRenderFns } from "./TimetableItem.vue?vue&type=template&id=1c6c7d20&scoped=true&"
import script from "./TimetableItem.vue?vue&type=script&lang=js&"
export * from "./TimetableItem.vue?vue&type=script&lang=js&"
import style0 from "./TimetableItem.vue?vue&type=style&index=0&id=1c6c7d20&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c6c7d20",
  null
  
)

component.options.__file = "TimetableItem.vue"
export default component.exports